<template>
    <div class="mobile-card">
        <div class="card-title" :style="titleStyle" v-if="showTitle">
            <div class="card-title-div">
                <slot name="title"></slot>
            </div>
        </div>
        <div v-if="showTitle" class="mobile-title-card-line"></div>
        <div class="card-content" :style="{paddingTop:paddingTop?paddingTop:''}">
            <slot name="content"></slot>
        </div>
        <div class="card-footer" v-if="showFooter">
            <div class="mobile-card-line"></div>
            <slot name="footer"></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: "mobileCard",
        props: {
            showFooter: {
                type: Boolean,
                default: false,
            },
            showTitle: {
                type: Boolean,
                default: true,
            },
            titleColor: {
                type: String,
            },
            paddingTop: {
                type: String,
            },
        },
        data() {
            return {}
        },
        computed: {
            // showFooter() {
            //     console.log("slots is", this.$scopedSlots)
            //     return this.$scopedSlots.footer !== undefined
            // },
            titleStyle() {
                if (this.titleColor) {
                    return {
                        background: this.titleColor,
                    }
                }
                return {}
            }
        },
        methods: {},
        created() {
        },
        mounted() {
        },
    }
</script>
<style lang="scss" scoped>
    .mobile-card {
        //width: 90vw;
        margin: 2vh 2vw;
        background: #ffffff;
        border-radius: 8px;

        .card-title {
            padding: 0 4vw;
            /*font-size: 16px;*/
            /*font-weight: bold;*/
            color: #005423;
            background: #e9e9e9;
            height: 6vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-radius: 5px 5px 0 0;

            .card-title-div {
                align-self: flex-start;
            }
        }

        .card-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 2vh 0 1vh 0;

            .card-content-div {
                align-self: flex-start;
            }
        }
    }

    .mobile-card-line {
        margin-left: 8px;
        margin-right: 8px;
        border: 1px solid #e9e9e9;
    }

    .mobile-title-card-line {
        border: 1px solid #e9e9e9;
    }
</style>
